import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=b70b490a&"
var script = {}
import style0 from "./Steps.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports